'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {Button} from '../../../components/buttons/Button';
import {FormField} from '../../../components/forms/FormField';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {stopPropagation} from '../../../core-utilities/react-utils';

const constraints = {
  nullable: false,
};

export function BaseUserProfileView(props) {
  return (
    <form
      className="UserProfile card full-height-flex modal-auto-centered"
      onClick={stopPropagation}
      onSubmit={props.onClickSave}
    >
      <div className="heading">
        {props.avatar}
        {props.name}
      </div>
      <div className="UserProfile__scrollPanel">
        <div className="UserProfile__scroll">
          <div className="form-response UserProfile__fields">
            <FormField
              className="UserProfile__field"
              type="text"
              label={props.firstNameLabel}
              value={props.firstName}
              constraints={constraints}
              validateImmediately={props.validateImmediately}
              isEditing={true}
              isSaving={props.isFetching}
              onChange={props.onChangeFirstName}
            />
            <FormField
              className="UserProfile__field"
              type="text"
              label={props.lastNameLabel}
              value={props.lastName}
              constraints={constraints}
              validateImmediately={props.validateImmediately}
              isEditing={true}
              isSaving={props.isFetching}
              onChange={props.onChangeLastName}
            />
            <FormField
              className="UserProfile__field"
              type="text"
              label={props.displayNameLabel}
              value={props.name}
              constraints={constraints}
              validateImmediately={props.validateImmediately}
              isEditing={true}
              isSaving={props.isFetching}
              onChange={props.onChangeName}
            />
            <FormField
              className="UserProfile__field"
              type="email"
              label={props.emailLabel}
              value={props.email}
              disabled={true}
              isEditing={true}
              isSaving={props.isFetching}
            />
          </div>

        </div>
      </div>
      <div className="UserProfile__button-bar button-bar fixed-bottom-modal">
        <Button
          className={classNames('UserProfile__button UserProfile__button_save button', {
            'UserProfile__button_fetching': props.isFetching,
          })}
          disabled={props.isSaveDisabled || props.isFetching}
          label={props.saveButtonLabel}
          onClick={props.onClickSave}
        />
        <Button
          className={classNames('UserProfile__button UserProfile__button_cancel button', {
            'UserProfile__button_fetching': props.isFetching,
          })}
          disabled={props.isFetching}
          label={props.cancelButtonLabel}
          onClick={props.onClickCancel}
        />
      </div>
    </form>
  );
}

BaseUserProfileView.propTypes = {
  email: T.string,
  name: T.string,
  firstName: T.string,
  lastName: T.string,

  onChangeName: T.func,
  onChangeFirstName: T.func,
  onChangeLastName: T.func,
  onClickCancel: T.func,
  onClickSave: T.func,
  isSaveDisabled: T.bool,
  isFetching: T.bool,
  showSuccess: T.bool,
  // Testing: Needed for storybook error states
  validateImmediately: T.bool,

  avatar: T.element.isRequired,

  displayNameLabel: T.string,
  firstNameLabel: T.string,
  lastNameLabel: T.string,
  emailLabel: T.string,
  saveButtonLabel: T.string,
  cancelButtonLabel: T.string,
};

export const UserProfileView = I18nComponent(BaseUserProfileView, [
  {code: 'onboarding.join.displayname', prop: 'displayNameLabel'},
  {code: 'onboarding.join.first', prop: 'firstNameLabel'},
  {code: 'onboarding.join.last', prop: 'lastNameLabel'},
  {code: 'onboarding.join.email', prop: 'emailLabel'},
  {code: 'default.button.save.label', prop: 'saveButtonLabel'},
  {code: 'default.button.cancel.label', prop: 'cancelButtonLabel'},
]);

UserProfileView.avatarClass = BaseUserProfileView.avatarClass = 'UserProfile__avatar';
UserProfileView.avatarIconClass = BaseUserProfileView.avatarIconClass = 'UserProfile__avatarIcon';



// WEBPACK FOOTER //
// ./src/js/user-profile/compoments/UserProfile/UserProfileView.js